<template>
	<v-dialog v-model="dialog" max-width="500">
		<v-card>
			<v-card-title class="py-2">
				#{{ detalhe.idsolicitacoes }} - {{ detalhe.nome }}
				<v-spacer></v-spacer>
				<v-chip :color="getStatusColor(detalhe.status)" dark x-small>
					{{ detalhe.status }}
				</v-chip>
			</v-card-title>
			<v-divider></v-divider>
			<v-card-text class="py-3">
				<v-row dense>
					<v-col cols="6">
						<span class="caption grey--text">TIPO</span>
						<div class="body-2 font-weight-medium">{{ detalhe.tipo }}</div>
					</v-col>
					<v-col cols="6">
						<span class="caption grey--text">DATA SOLICITADA</span>
						<div class="body-2 font-weight-medium">{{ formatoData(detalhe.data_solicitacao) }}</div>
					</v-col>
					<v-col v-if="detalhe.turno_atual" cols="12">
						<span class="caption grey--text">TROCA DE TURNO</span>
						<div class="body-2">
							<v-chip x-small color="blue-grey" dark class="mr-1">{{ detalhe.turno_atual }}</v-chip>
							<v-icon small>mdi-arrow-right</v-icon>
							<v-chip x-small color="primary" dark class="ml-1">{{ detalhe.turno_desejado }}</v-chip>
						</div>
					</v-col>
				</v-row>

				<v-divider class="my-3"></v-divider>

				<div class="mb-3">
					<span class="caption grey--text">JUSTIFICATIVA</span>
					<div class="body-2 mt-1">{{ detalhe.justificativa }}</div>
				</div>

				<div v-if="detalhe.atestado_medico" class="mb-3">
					<span class="caption grey--text">ANEXO</span>
					<div class="mt-1">
						<v-btn x-small outlined color="primary" @click="downloadAtestado">
							<v-icon left x-small>mdi-file-document</v-icon>
							Atestado Médico
						</v-btn>
					</div>
				</div>

				<v-divider v-if="detalhe.resposta || (canManage && detalhe.status === 'Pendente')"
					class="my-3"></v-divider>

				<div v-if="canManage && detalhe.status === 'Pendente'">
					<span class="caption grey--text">RESPOSTA DA GESTÃO</span>
					<v-textarea v-model="resposta" placeholder="Digite sua resposta..." rows="2" dense outlined
						hide-details class="mt-1"></v-textarea>
				</div>
				<div v-else-if="detalhe.resposta">
					<span class="caption grey--text">RESPOSTA DA GESTÃO</span>
					<div class="body-2 mt-1 pa-2 grey lighten-4 rounded">{{ detalhe.resposta }}</div>
				</div>
			</v-card-text>
			<v-card-actions class="py-2">
				<v-spacer></v-spacer>
				<v-btn text small @click="reset">Fechar</v-btn>
				<v-btn v-if="canManage && detalhe.status === 'Pendente'" color="error" small
					@click="updateStatus('Recusado')" :loading="loading">
					Recusar
				</v-btn>
				<v-btn v-if="canManage && detalhe.status === 'Pendente'" color="success" small
					@click="updateStatus('Aprovado')" :loading="loading">
					Aprovar
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from 'axios'
import { baseApiUrl, showError } from '@/global'
import { mapState } from 'vuex'
import Bus from '@/barramento'
import moment from 'moment'

export default {
	name: 'DialogDetalhes',
	data() {
		return {
			detalhe: {},
			dialog: false,
			resposta: '',
			loading: false
		}
	},
	computed: {
		...mapState(['user']),
		canManage() {
			return ['Master', 'Admin', 'Gerente', 'Supervisor'].includes(this.user.tipo)
		}
	},
	methods: {
		loadDetalhes(item) {
			this.detalhe = { ...item }
			this.resposta = item.resposta || ''
			this.dialog = true
		},
		async updateStatus(status) {
			this.loading = true
			try {
				await axios.put(`${baseApiUrl}/solicitacoes/${this.detalhe.idsolicitacoes}/status`, {
					status,
					resposta: this.resposta
				})
				this.$toasted.global.defaultSuccess()
				Bus.$emit('reload')
				this.reset()
			} catch (err) {
				showError(err)
			} finally {
				this.loading = false
			}
		},
		downloadAtestado() {
			if (this.detalhe.atestado_medico) {
				window.open(`${baseApiUrl}/uploads/${this.detalhe.atestado_medico}`, '_blank')
			}
		},
		getStatusColor(status) {
			switch (status) {
				case 'Pendente': return 'orange'
				case 'Aprovado': return 'green'
				case 'Recusado': return 'red'
				default: return 'grey'
			}
		},
		reset() {
			this.dialog = false
			this.detalhe = {}
			this.resposta = ''
		},
		formatoData(data) {
			return data ? moment(data).format('DD/MM/YYYY') : ''
		}
	},
	mounted() {
		Bus.$on('loadDetalhes', this.loadDetalhes)
	},
	beforeDestroy() {
		Bus.$off('loadDetalhes', this.loadDetalhes)
	}
}
</script>